module.exports = __webpack_public_path__ + "static/media/nightBackground@2x.f48360a6.jpg";